import styled from 'styled-components';
import TwoPeopleSvg from '../assets/hotels/details/two-people.svg';

const TwoPeopleIcon = styled(TwoPeopleSvg as JSX.Element)(
  props => `
  width: ${props => props.width || 'auto'};
  height: ${props => props.height || 'auto'};
  margin: ${props => props.margin || 'auto'};
  cursor: pointer;

  path {
    fill: ${props.fill || props.theme.colors.downriver.medium};
  }

  // transform: ${props.transform || 'scale(1)'}
`,
);

export default TwoPeopleIcon;
